// UserProvider.js

import { createContext, useContext, useEffect, useState } from "react";
import api from "../../src/api";

const userContext = createContext();

const UserProvider = ({ children }) => {
    const [state, setState] = useState({
        user: null,
        loading: true,
        name: null,
        _id: null
    });

    useEffect(() => {
        let cancelled = false;

        const fetchSessionData = async (attempt = 0) => {
            try {
                const { data } = await api.get(`auth/session_data`, { withCredentials: true });
                if (cancelled) return;
                setState({ user: data, loading: false, name: data.name, _id: data._id });
            } catch (error) {
                if (cancelled) return;
                // 429 is a transient rate limit, not a missing session. Clearing the
                // user here would bounce someone with valid cookies to /login, so
                // retry with backoff instead (loading stays true meanwhile).
                if (error?.response?.status === 429 && attempt < 2) {
                    setTimeout(() => fetchSessionData(attempt + 1), 2000 * (attempt + 1));
                    return;
                }
                setState({ user: null, loading: false, name: null });
            }
        };

        fetchSessionData();

        return () => {
            cancelled = true;
        };
    }, []);

    return (
        <userContext.Provider value={[state, setState]}>
            {children}
        </userContext.Provider>
    );
};

const useAuth = () => useContext(userContext);

export { useAuth, UserProvider };
